import { useTranslation } from '@/i18n';
import { GetApPayeeInfoResponseApInvoiceTransactionDefaultValue } from 'ap-openapi';
import classnames from 'classnames/bind';
import { FC } from 'react';
import styles from '../../styles.module.scss';
import { AnchorItemKey, PaymentRuleData } from '../../types';
import { HeaderSection } from '../Common';
import { PaymentRule } from './PaymentRule';
import { TransactionDetail } from './TransactionDetail';

const cx = classnames.bind(styles);

type DefaultPaymentMethodProps = {
  paymentRule?: PaymentRuleData;
  transactionDefaultValue?: GetApPayeeInfoResponseApInvoiceTransactionDefaultValue;
  apPayeeId: string;
  isEditable?: boolean;
};

export const DefaultPaymentMethod: FC<DefaultPaymentMethodProps> = ({
  paymentRule,
  transactionDefaultValue,
  apPayeeId,
  isEditable = false,
}) => {
  const { t } = useTranslation();

  return (
    <div
      id={AnchorItemKey.DEFAULT_PAYMENT_METHOD}
      className={cx(['sectionContainer', 'groupedSectionContainer'])}
    >
      <HeaderSection
        displayName={t('ap_payee_detail_drawer_default_payment_method')}
      />
      <PaymentRule paymentRule={paymentRule} />
      <TransactionDetail
        transactionDefaultValue={transactionDefaultValue}
        apPayeeId={apPayeeId}
        isEditable={isEditable}
      />
    </div>
  );
};

DefaultPaymentMethod.displayName = 'DefaultPaymentMethod';
